import * as React from "react";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { Pagination, Stack } from "@mui/material";
import styles from "../styles.module.css";
import { ReactComponent as InfoOptionSvg } from "../../../../assets/infoOption.svg";
import { observer } from "mobx-react-lite";
import { ITransactionModel } from "../../../../app/models/user";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { ReactComponent as NoRecordSvg } from "../../../../assets/norecord.svg";
import PaginationComponent from "../../../../app/common/pagination/PaginationComponent";
import { dateLocale } from "../../../../app/common/hooks/helpers";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#32C36C",
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

function createData(
  name: string,
  calories: string,
  fat: number,
  carbs: string,
  protein: string,
  date: string
) {
  return { name, calories, fat, carbs, protein, date };
}

const rows = [
  createData(
    "johndoe@gmail.com",
    "75,000",
    88293001887883,
    "Card",
    "Successful",
    "12 - Feb - 2022 | 12:34pm"
  ),
  createData(
    "johndoe@gmail.com",
    "75,000",
    88293001887883,
    "Alt Finance",
    "Failed",
    "12 - Feb - 2022 | 12:34pm"
  ),
  createData(
    "johndoe@gmail.com",
    "75,000",
    88293001887883,
    "Alt Finance",
    "Failed",
    "12 - Feb - 2022 | 12:34pm"
  ),
  createData(
    "johndoe@gmail.com",
    "75,000",
    88293001887883,
    "Card",
    "Successful",
    "12 - Feb - 2022 | 12:34pm"
  ),
  createData(
    "johndoe@gmail.com",
    "75,000",
    88293001887883,
    "Card",
    "Successful",
    "12 - Feb - 2022 | 12:34pm"
  ),
  createData(
    "johndoe@gmail.com",
    "75,000",
    88293001887883,
    "Card",
    "Successful",
    "12 - Feb - 2022 | 12:34pm"
  ),
];
interface Props {
  transactionList: ITransactionModel[];
}
const AllTransactions = ({ transactionList }: Props) => {
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const [postsPerPage] = useState(7);

  // Get current posts
  const indexOfLastPost = currentPage * postsPerPage;
  const indexOfFirstPost = indexOfLastPost - postsPerPage;
  const currentTransactionList = transactionList.slice(
    indexOfFirstPost,
    indexOfLastPost
  );

  // Change page
  const paginate = (pageNumber: number) => setCurrentPage(pageNumber);
  return (
    <>
      {transactionList.length > 0 ? (
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 700 }} aria-label="customized table">
            <TableHead>
              <TableRow>
                <StyledTableCell>SN</StyledTableCell>
                <StyledTableCell>User</StyledTableCell>
                <StyledTableCell>Amount</StyledTableCell>
                <StyledTableCell>Transaction Ref.</StyledTableCell>
                <StyledTableCell>Payment Method</StyledTableCell>
                <StyledTableCell>Status</StyledTableCell>
                <StyledTableCell>Date of Payment</StyledTableCell>
                <StyledTableCell></StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {transactionList.map((row, index) => (
                <StyledTableRow key={index}>
                  <StyledTableCell component="th" scope="row">
                    {index + 1}
                  </StyledTableCell>
                  <StyledTableCell>{row.customerName}</StyledTableCell>
                  <StyledTableCell>{row.amount}</StyledTableCell>
                  <StyledTableCell>{row.transactionReference}</StyledTableCell>
                  <StyledTableCell>{row.paymentMethod}</StyledTableCell>
                  <StyledTableCell>{row.paymentStatus}</StyledTableCell>
                  <StyledTableCell>
                    {dateLocale(row.paymentDate)}
                  </StyledTableCell>
                  <StyledTableCell>
                    <InfoOptionSvg />
                  </StyledTableCell>
                </StyledTableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      ) : (
        <div className={styles.norecord}>
          <NoRecordSvg />
        </div>
      )}
      {transactionList.length > 0 && (
        <div className={styles.pagination}>
          <PaginationComponent
            postsPerPage={postsPerPage}
            totalPosts={transactionList.length}
            paginate={paginate}
            currentPage={currentPage}
          />
        </div>
      )}
    </>
  );
};
export default observer(AllTransactions);
